import {
  AlignType,
  ETextStyleVariant,
  GeneralShieldPlusIcon,
  GeneralShieldStarIcon,
  GeneralShieldUnfilledIcon,
  Selector,
  SizeVariant,
  Text,
} from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TCurrency } from '@/config/locales';
import { IInsuranceBundle } from '@/services/types/booking/insuranceBundle';
import { formatCurrency } from '@/utility/currency';

interface IInsuranceRadioProps {
  disabled?: boolean;
  checked: boolean;
  index: number;
  currency: TCurrency;
  insuranceBundle: IInsuranceBundle;
  onChange: () => void;
  isCurrentPlan?: boolean | null;
}

const InsuranceRadio: React.FC<IInsuranceRadioProps> = ({
  disabled,
  index,
  checked,
  currency,
  insuranceBundle,
  onChange,
  isCurrentPlan = null,
}) => {
  const priceLabel = formatCurrency({
    priceInCents: insuranceBundle.total_price,
    currency: currency,
    digits: 2,
  });

  let Icon = null;
  switch (index) {
    case 0:
      Icon = GeneralShieldUnfilledIcon;
      break;
    case 1:
      Icon = GeneralShieldPlusIcon;
      break;
    case 2:
      Icon = GeneralShieldStarIcon;
      break;
    default:
      Icon = GeneralShieldUnfilledIcon;
      break;
  }

  return (
    <div className="flex flex-col items-center justify-end h-full">
      {isCurrentPlan === true && (
        <Text component="p" className="mb-2 text-xs text-center text-gray-500 font-highlight">
          <FormattedMessage defaultMessage="CURRENT PLAN" id="SaYYW7" />
        </Text>
      )}
      {isCurrentPlan === null && index === 1 && (
        <Text component="p" className={cn('mb-2 text-xs text-center font-medium text-gray-500')}>
          <FormattedMessage defaultMessage="RECOMMENDED" id="/CXAa1" />
        </Text>
      )}
      <Selector
        disabled={disabled}
        alignVariant={AlignType.VerticalLeft}
        label={insuranceBundle.name}
        ariaLabel={insuranceBundle.name}
        labelVariant={ETextStyleVariant.MediumBold}
        secondaryLabel={priceLabel}
        secondaryLabelVariant={ETextStyleVariant.SmallRegular}
        contentWrapperClassName="text-left"
        size={SizeVariant.Default}
        name={insuranceBundle.name}
        labelClassName="h-full text-xs md:text-base"
        value={insuranceBundle.id}
        icon={Icon}
        onChange={onChange}
        isSelected={checked}
        data-testid={`${insuranceBundle.id}-bundle-id`}
        className="w-full"
      />
    </div>
  );
};

export default InsuranceRadio;
